Namespace 'Customer.Dashboard'

class Customer.Dashboard.MassiveUpdateView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/massive_update"]

  events:
    'click #confirm': '_onConfirm'
    'click #cancel': '_onCancel'

  initialize: (@options = {}) ->
    @modalElement = ''
    @model = @options.model
    @includeNotLoaded = @options.includeNotLoaded
    @filterId = @options.filterId
    @query = @options.query
    @notifier = new Customer.Notifier(model: @model)
    @taxonomyAttributes = @options.taxonomyAttributes
    @conversationAttributes = @options.conversationAttributes
    @taxonomyAttributesChosenViews = {}
    @totalSelected = if @includeNotLoaded then @options.total else @model.selected().length
    @assignmentView = new Customer.Dashboard.AssignmentView(@options.usersGroups, @model, @options.users)
    @massiveCloseView = new Customer.Ticket.MassiveCloseView(model: @model)

  show: ->
    $(@$el).append(@modalElement) if @modalElement
    @modalElement = ''
    @$el.find('#update_all').modal()

  hide: ->
    @_keepCustomerSessionAlive()
    @$el.find('#update_all').modal('hide')
    setTimeout =>
      @modalElement = @$el.find('#update_all').detach() unless @modalElement
    , 1000

  render: ->
    @$el.html(@template({total: @totalSelected, taxonomyAttributes: @taxonomyAttributes}))
    @$el.find('.assignment').append "<span id='title'> #{I18n.t('customer.dashboard.conversations.details.assign.prompt')}</span>"
    @$el.find('.assignment').append(@assignmentView.render().el)
    @$el.find('.close-all').append(@massiveCloseView.render().el)
    _.each(@taxonomyAttributes, (taxonomy) =>
      conversationAttribute = @conversationAttributes.find((conversationAttribute) => conversationAttribute.code == taxonomy.code)
      tags = taxonomy.tag_names
      tagsToBeAdded = new Monitoring.Views.Dashboards.ChosenTagsView
      tagsToBeRemoved = new Monitoring.Views.Dashboards.ChosenTagsView
      @taxonomyAttributesChosenViews[taxonomy.code] = {tagsToBeAdded: tagsToBeAdded, tagsToBeRemoved: tagsToBeRemoved}

      tagsToBeAdded.render()
      tagsToBeAdded.addSelectableTags(tags, I18n.t('monitoring.massive_actions.massive_tagging.add_tags'), conversationAttribute.multiple)
      @$('#taxo-'+taxonomy.code+'-add_tags').append(tagsToBeAdded.el)
      tagsToBeRemoved.render()
      tagsToBeRemoved.addSelectableTags(tags, I18n.t('monitoring.massive_actions.massive_tagging.remove_tags'), true)
      @$('#taxo-'+taxonomy.code+'-remove_tags').append(tagsToBeRemoved.el)
    )
    @

  remove: ->
    @assignmentView.remove()
    @assignmentView = undefined

    @massiveCloseView.remove()
    @massiveCloseView = undefined
    super

  updateCountWithNotLoaded: ->
    @includeNotLoaded = true
    @updateTotalCount()

  updateCountWithLoaded: ->
    @includeNotLoaded = false
    @updateTotalCount()

  updateTotalCount: ->
    @totalSelected = if @includeNotLoaded then @options.total else @model.selected().length
    @$el.find("#previewLabel").html(@totalSelected + " " + I18n.t('customer.dashboard.massive_update.modal.header.title'))

  _onConfirm: ->
    @hide()
    if @areChanges()
      swal({
        title: I18n.t('customer.dashboard.conversations.multiple.alert.you_are_about')
        text: @_warningText()
        type: 'warning'
        html: true
        showCancelButton: true
        cancelButtonText: I18n.t('customer.dashboard.conversations.multiple.alert.cancel')
        confirmButtonClass: 'btn-info'
        confirmButtonText: I18n.t('customer.dashboard.conversations.multiple.confirm')
      }, => @_callMassiveUpdate())
    else
      swal({
        title: I18n.t('customer.dashboard.massive_update.changes.no_changes_modal.title')
        text: I18n.t('customer.dashboard.massive_update.changes.no_changes_modal.text')
        type: 'warning'
      })

  areChanges: ->
    @_user_assignment_selected() || @_unassignment_selected() || @_group_assignment_selected() || @_status_change_selected() || @_tags_selected()

  _onCancel: ->
    @hide()

  _callMassiveUpdate: =>
    attributesChosenForEachTaxonomy = {}
    _.each(@taxonomyAttributes, (taxonomy) =>
      selectedToAdd = @taxonomyAttributesChosenViews[taxonomy.code].tagsToBeAdded.selectedOptions()
      selectedToRemove = @taxonomyAttributesChosenViews[taxonomy.code].tagsToBeRemoved.selectedOptions()
      attributesChosenForEachTaxonomy[taxonomy.code] = {tagsToBeAdded: selectedToAdd, tagsToBeRemoved: selectedToRemove}
    )
    attributes = _.extend({}, @assignmentView.selectedOption.attributes, @massiveCloseView.selectedOption)
    attributes['taxonomy_attributes'] = attributesChosenForEachTaxonomy
    if @includeNotLoaded
      @model.countTicketsForMassiveUpdate(@filterId, attributes, @query)
    else
      @model.countTicketsForUpdate(attributes)
    @_sendNotification(@assignmentView.selectedOption)

  _sendNotification: (options) ->
    if options.userId
      @notifier.sendNotifications(options.assignedToName, [options.userId])
    else if options.groupId
      @notifier.sendGroupNotifications(@options.usersGroups, options.groupId)

  _warningText: ->
    actions = "<ul>#{@_actions()}</ul>"
    actions += "<span style=\"color: red\">#{@_translated_simple_attribute_warning()}</span>" if @_tags_selected()
    actions
 
  _actions: ->
    [
      "<li>#{@_user_assignment_action()}</li>" if @_user_assignment_selected(),
      "<li>#{@_unassignment_action()}</li>" if @_unassignment_selected(),
      "<li>#{@_group_assignment_action()}</li>" if @_group_assignment_selected(),
      "<li>#{@_status_change_action()}</li>" if @_status_change_selected(),
      "<li>#{@_attributes_change_action()}</li>" if @_tags_selected(),
    ].join('') or "<li>#{I18n.t('customer.dashboard.conversations.multiple.alert.do_nothing')}</li>"

  _unassignment_selected: ->
    @assignmentView.selectedOption.assignedToName? && !@assignmentView.selectedOption.assignedToGroupName? && !@assignmentView.selectedOption.attributes.assigned_to_id?

  _unassignment_action: ->
    I18n.t(
      'customer.dashboard.conversations.multiple.alert.assign_to_nobody'
    )

  _user_assignment_selected: ->
    @assignmentView.selectedOption.attributes.assigned_to_id?

  _user_assignment_action: ->
    I18n.t(
      'customer.dashboard.conversations.multiple.alert.assign_to_user',
      user: @assignmentView.selectedOption.assignedToName
    )

  _group_assignment_selected: ->
    @assignmentView.selectedOption.attributes.users_group_id? and not @_user_assignment_selected()

  _group_assignment_action: ->
    I18n.t(
      'customer.dashboard.conversations.multiple.alert.assign_to_group',
      group: @assignmentView.selectedOption.assignedToGroupName
    )

  _status_change_selected: ->
    @massiveCloseView.selectedOption.status?

  _tags_selected: ->
    result = false
    _.each(@taxonomyAttributes, (taxonomy) =>
      selectedToAdd = @taxonomyAttributesChosenViews[taxonomy.code].tagsToBeAdded.selectedOptions()
      selectedToRemove = @taxonomyAttributesChosenViews[taxonomy.code].tagsToBeRemoved.selectedOptions()
      result = result || selectedToAdd.length > 0 || selectedToRemove.length > 0
    )
    return result

  _status_change_action: ->
    I18n.t 'customer.dashboard.conversations.multiple.alert.change_status', status: @_translated_status()

  _attributes_change_action: ->
    I18n.t 'customer.dashboard.massive_update.changes.attributes'

  _translated_status: ->
    I18n.t "customer.dashboard.conversations.status.#{@massiveCloseView.selectedOption.status.toLowerCase()}"

  _translated_simple_attribute_warning: ->
    I18n.t 'customer.dashboard.massive_update.changes.simple_attributes_warning'

  toggleConfirmBtn: (hasValue) ->
    @$el.find('#confirm').prop('disabled', !hasValue)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
